import { ChangeDetectionStrategy, Component, Input, InputSignal, OnInit, Signal, inject, input } from "@angular/core";
import { EvCore } from "ev-core";
import { Owner } from "src/models/units/owner.model";
import { ExternalLinksService } from "src/services/externallinks.service";
import { IMiniInfocardCommercial } from "src/models/commercial/IMiniInfocardDataCommercial.model";
import { ImagePackage } from "src/models/common/image.model";
import { EvCircularProgressComponent } from "src/app/shared-components/ev-circular-progress/ev-circular-progress.component";
import { ImageCarouselComponent } from "src/app/shared-components/image-carousel/image-carousel.component";

@Component({
    selector: "mini-infocard-image-carousel",
    imports: [EvCore, EvCircularProgressComponent, ImageCarouselComponent],
    templateUrl: "./mini-infocard-image-carousel.component.html",
    styleUrl: "./mini-infocard-image-carousel.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MiniInfocardImageCarouselComponent implements OnInit {
    selectedSale: InputSignal<IMiniInfocardCommercial> = input.required();
    imagePackages: InputSignal<ImagePackage[]> = input([]);

    streetViewUrl: string = "";
    private readonly exLinksService: ExternalLinksService = inject(ExternalLinksService);

    ngOnInit(): void {
        this.streetViewUrl = this.exLinksService.makeStreetViewUrl(this.selectedSale().decimalLatitude, this.selectedSale().decimalLongitude);
    }

    getOwnerPercentage(owner: Owner): number {
        if (owner?.ownerShare?.numerator && owner?.ownerShare?.denominator) {
            return (owner.ownerShare.numerator / owner.ownerShare.denominator) * 100;
        }
        return 0;
    }
}
